import AutomaticRepliesOptionViewState from './schema/AutomaticRepliesOptionViewState';
import getAutomaticRepliesOptionStateDefaultValue from '../../utils/getAutomaticRepliesOptionStateDefaultValue';
import { createStore } from 'satcheljs';

export default createStore<AutomaticRepliesOptionViewState>('automaticRepliesOption', {
    initialState: getAutomaticRepliesOptionStateDefaultValue(),
    currentState: getAutomaticRepliesOptionStateDefaultValue(),
    selectedCalendarIds: [],
});
